export class UserHelper {
  static getShortName(surname: string, name: string, patronymic: string): string {
    let shortName = '';
    if (surname !== '') {
      shortName += surname + ' ';
    }
    if (name !== '') {
      shortName += name[0] + '.';
    }
    if (patronymic !== '') {
      shortName += ' ' + patronymic[0] + '.';
    }

    return shortName;
  }

  static getFullName(surname: string, name: string, patronymic: string): string {
    let fullName = '';
    if (surname !== '') {
      fullName += surname;
    }
    if (name !== '') {
      fullName += ' ' + name;
    }
    if (patronymic !== '') {
      fullName += ' ' + patronymic;
    }

    return fullName;
  }
}
